import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export class ConfirmDialog {
  title = "Leave Assessment?";
  message = `Are you sure you want to leave the CPD Self-Assessment?`;
  message2 = `Your progress on the current step will not be saved. You have not completed the assessment.`
  message3 = ``;
  okButtonTitle = 'Leave';
  cancelButtonTitle = 'Cancel';
  thirdButtonTitle = '';
}

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.css'],
    standalone: false
})
export class ConfirmationDialogComponent {
  confirmDialog: ConfirmDialog;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialog) {
    this.confirmDialog = data;
  }
}
